import { createContext } from "react";

const PrevDataContext = createContext();
export default PrevDataContext;
